// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"b6663a22","151":"d3f0a564","185":"2bffa9f2","196":"43c01093","200":"0a9eb69b","206":"72cb73c0","502":"2fc4c716","641":"41652718","672":"f0371c70","738":"5d126538","947":"de2ec562"}[chunkId] + ".chunk.js";
};